import React,{ useState,useEffect } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  Button,
  required
} from 'react-admin';
import { reparseNotam } from '../../lib/api';
import { useAbortSignal } from '../../lib/hooks';

const NotamsEdit: React.FC = (props: any) => {
  const [parsingResult,setParsingResult] = useState('');
  const signal = useAbortSignal();
  var parseNotam = async function(body: any) {
    setParsingResult('')
    const res = await reparseNotam({
      id: props.id,
      body: body,
      status: 'parsed'
    }, signal)
    setParsingResult(res.body)
  }
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source='id' disabled/>
        <TextInput
          source='status'
          validate={[
            required()
          ]}
        />
        <TextInput
          source='body'
          fullWidth
          multiline
          onChange={(e: any) => {
            parseNotam(e.target.value)
          }}
          validate={[
            required()
          ]}
        />
        {parsingResult && 
          <div className="MuiFormControl-marginDense MuiFormControl-fullWidth width-100percent">
            <textarea disabled value={parsingResult} rows={5} style={{ width: '100%'}}></textarea>
          </div>
        }
        <TextInput source='recvAt'
          validate={[
            required()
          ]}/>
        <TextInput source='sendAt'
          validate={[
            required()
          ]}/>
        <TextInput
          source='log'
          fullWidth
          disabled
          multiline
        />
        <TextInput source='resultNotamsIds'
          disabled
        />
        
      </SimpleForm>
    </Edit>
  );
};

export default NotamsEdit;